import { ButtonCustom } from "@/components/ui/button-custom";
import { Zap } from "lucide-react";
import { toast } from "sonner";
import { useState } from "react";

export const BoostSpeedButton = () => {
  const [isLoading, setIsLoading] = useState(false);

  const handleBoostSpeed = async () => {
    setIsLoading(true);
    
    try {
      // Unregister service workers
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map(reg => reg.unregister()));
      }

      // Clear cache storage
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(name => caches.delete(name)));
      }

      // Clear local storage and session storage
      localStorage.clear();
      sessionStorage.clear();

      // Clear IndexedDB
      if ('indexedDB' in window) {
        const databases = await indexedDB.databases();
        databases.forEach(db => {
          if (db.name) indexedDB.deleteDatabase(db.name);
        });
      }

      toast.success("تم تحسين السرعة بنجاح!", {
        description: "سيتم إعادة تحميل الصفحة الآن..."
      });

      // Hard reload
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      toast.error("حدث خطأ أثناء التحسين", {
        description: "يرجى المحاولة مرة أخرى"
      });
      setIsLoading(false);
    }
  };

  return (
    <ButtonCustom
      variant="ghost"
      size="icon"
      onClick={handleBoostSpeed}
      disabled={isLoading}
      className="w-10 h-10 rounded-lg"
      aria-label="Boost"
    >
      <Zap className={`w-6 h-6 ${isLoading ? 'animate-spin' : ''}`} />
    </ButtonCustom>
  );
};
